// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1rn1w","name":"ConsentHeader_name__o4tzV","birthday":"ConsentHeader_birthday__15o8v","skeleton":"ConsentHeader_skeleton__1bi0l"};